import { ColDef } from 'ag-grid-community';
import {
  createDateCol,
  createIndexCol,
  createTypoCol,
} from '@/src/helpers/agColumnHelper';

export const noticeListColumn = (): ColDef[] => [
  createIndexCol(),
  createTypoCol({
    field: 'titleKr',
    width: 317,
  }),
  createTypoCol({
    field: 'titleEn',
    width: 317,
  }),
  createDateCol({
    field: 'createdAt',
    width: 131,
    minWidth: 131,
  }),
  createDateCol({
    field: 'updatedAt',
    width: 131,
    minWidth: 131,
  }),
];
